import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class PromoCode extends ApplicationRecord {
  static jsonapiType = 'promo-codes';

  @Attr() code: string;
  @Attr() dropOffStart?: string;
  @Attr() dropOffEnd?: string;
  @Attr() readonly discountRate: string;
}
